export default "__VITE_ASSET__a9857503__"